import React from 'react';
import { Input } from 'antd';

export const LCInput = props => <Input {...props} />;

